import { createContext } from 'react';
import type { ORGANIZATION_TAB } from '@/types';

export type TabStatus = {
  [key in ORGANIZATION_TAB]: boolean;
};

type TabStatusContextType = {
  tabStatus: TabStatus;
  refreshTabStatus: () => Promise<void>;
  isLoading: boolean;
};

export const TabStatusContext = createContext<TabStatusContextType | null>(null);
